/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q8Inputs */

const en_home_faq_q8 = /** @type {(inputs: Home_Faq_Q8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I download CADCraft?`)
};

/**
* | output |
* | --- |
* | "How do I download CADCraft?" |
*
* @param {Home_Faq_Q8Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_faq_q8 = /** @type {((inputs?: Home_Faq_Q8Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q8Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_faq_q8(inputs)
});
export { home_faq_q8 as "home.faq.q8" }